import moment from "moment";

export const reworkFulfilments = (fulfilmentsToWork) => {
  let retObj = {};
  fulfilmentsToWork.map((fulfilment) => {
    let monthsYear = moment(fulfilment.fulfilmentDeadline).format("YYYYMM");
    if (!retObj[monthsYear]) {
      retObj[monthsYear] = {
        label: "generic.months." + moment(fulfilment.fulfilmentDeadline).format("MM"),
        year: moment(fulfilment.fulfilmentDeadline).format("YYYY"),
        fulfilments: []
      };
    }
    return retObj[moment(fulfilment.fulfilmentDeadline).format("YYYYMM")].fulfilments.push(fulfilment);
  });
  return retObj;
};
